import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/strip_p_tags_helper.js";
import "#legacy/handlebars_helpers/link_tool_helper.js";

(function (global) {
  global.headerTemplate = Handlebars.compile(
    '{{#if header}}<header {{#if header_class}} class="{{header_class}}" {{/if}} data-context-name="title">{{/if}}\
    <{{title_selector}} class="{{title_size}} {{class}}">\
      {{~linkTool title~}}\
    </{{title_selector}}>\
  {{#if header}}</header>{{/if}}',
  );

  Handlebars.registerHelper("linkedTitle", function (title_size, title, options) {
    var output = "";
    var title_options = options.hash;

    // Check for old style non-object title
    if (typeof title === "string") {
      this.title = { text: title };
    }

    if (this.title && this.title.text) {
      this.title.text = Handlebars.helpers.stripPTags(this.title.text);
      this.title_size = title_size || "linked-title--section";
      this.title_selector = title_options.selector || "h2";
      this.class = title_options.class;
      this.header = title_options.header;
      this.header_class = title_options.header_class;

      output = global.headerTemplate(this);
    }

    return new Handlebars.SafeString(output);
  });
})(typeof window !== "undefined" ? window : this);
